import { observable } from 'mobx';

class Parameters {
  @observable _parameters = {
    sliceFileLinkPath: '/slice-file-link-path'
  };

  getAll() {
    return this._parameters;
  }

  update(parameters) {
    this._parameters = parameters;
  }
}

export default Parameters;



// WEBPACK FOOTER //
// ./src/stores/Parameters.js